import * as yup from 'yup';
import {
  ReleaseVersion,
  UpdateReleaseVersionValidations,
  UpdateTuneCoreReleaseVersionPatchData,
} from 'types/releases';
import { fieldValidationMessages } from 'app/constants';
import { DDL, Option } from 'types/general.types';
import { Audio } from 'types/audio';
import {
  getLanguage,
  getReleaseSongVersionProperty,
} from 'app/components/Releases/utils';
import { TuneCoreVersionDetailsFormData } from './types';

export interface AudioData {
  items: Audio[];
  latestAudioGuid?: string;
}

export const getUpdateVersionValidationSchema = (
  metadataValidations: UpdateReleaseVersionValidations
) => {
  const { versionTitle } = metadataValidations;

  return yup.object().shape({
    versionTitle: yup
      .string()
      .required(fieldValidationMessages.REQUIRED)
      .max(
        versionTitle.maxLength,
        fieldValidationMessages.MAX_CHAR(versionTitle.maxLength)
      ),
  });
};

export const getFirstDefaultGenre = (
  genres: string[] = [],
  genresDDL: DDL
): Option | null => {
  const firstGenre = genresDDL[genres[0]];
  return firstGenre
    ? ({ title: firstGenre.name, value: firstGenre.key } as Option)
    : null;
};

export const getPreferredAudioSelectionOption = (audio: Audio | null) => {
  return audio
    ? {
        title: audio.title,
        value: audio.guid,
        latest: audio.isLatestVersion,
        audioData: audio,
      }
    : null;
};

export const getDefaultValues = (
  version: ReleaseVersion,
  genresDDL: DDL,
  languageCodes: DDL
): TuneCoreVersionDetailsFormData => {
  return {
    versionTitle: version.metadata?.versionTitle || '',
    genre: getFirstDefaultGenre(version.song.snapshot.genres || [], genresDDL),
    language: getLanguage(
      languageCodes,
      getReleaseSongVersionProperty(version.song, 'language')
    ),
    explicit: version.song.snapshot.explicit || false,
    type: version.metadata.type,
    excludeLyrics: version.lyrics?.isExcluded || false,
  };
};
export const convertTCFormDataToVersionPatchData: (
  data: Partial<TuneCoreVersionDetailsFormData>
) => UpdateTuneCoreReleaseVersionPatchData = (data) => {
  const songData = {
    ...(data.genres ? { genres: data.genres } : {}),
    ...(data.explicit !== undefined ? { explicit: data.explicit } : {}),
    ...(data.language ? { language: data.language.value } : {}),
  };
  const isSongDataNotEmpty = Object.values(songData).length > 0;

  return {
    ...(data.versionTitle ? { versionTitle: data.versionTitle } : {}),
    ...(data.type ? { type: data.type } : {}),
    ...(data.excludeLyrics !== undefined
      ? { excludeLyrics: data.excludeLyrics }
      : {}),
    ...(isSongDataNotEmpty
      ? {
          song: songData,
        }
      : {}),
  };
};
